import React, { useState, useMemo, FC, useEffect, createRef, Fragment } from 'react'
import DataTable from 'react-data-table-component'
import 'bootstrap/dist/css/bootstrap.min.css'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight, faArrowsRotate, faChevronLeft, faChevronRight, faCog, faFile, faFilter, faInfoCircle, faLink, faMagnifyingGlass, faRotate } from '@fortawesome/free-solid-svg-icons'
import { PlatformDataType, PlatformProductMappingData, PlatformSettingsDataType } from 'src/interfaces/Platform.interface'
import { useAppDispatch, useAppSelector } from 'src/redux/storeHooks'
import { useRef } from 'react'
import Button from 'react-bootstrap/Button'
import Overlay from 'react-bootstrap/Overlay'
import { delistVariantsAsync, getAllPlatformTypesAsync, refreshPlatformDataAsync, } from 'src/redux/actions/platformActions'
import { toast } from 'react-toastify'
import { useParams } from 'react-router-dom'
import {
  getAllProductsVarientsFromChannelAsync, getAllProductsVarientsFromMainChannelAsync,
  linkProductVarientAsync, productVarientResyncAsync,
} from 'src/redux/actions/productActions'
import LinkButton from '../LinkButton'
import { getApiErrorMessage, isApiPayloadSuccess, KTIcon, KTSVG } from 'src/marketConnect/helpers'
import { Dropdown, DropdownButton, Modal, OverlayTrigger, Spinner, Tab, Tabs, Tooltip, Popover, Form } from 'react-bootstrap'
import CSVUploadModal from '../CSVUploadModal'
import Loader from 'src/utils/Loader'
import TableLoadingShell from 'src/utils/TableLoadingShell'
import CommonAlertModal from 'src/utils/modals/CommonAlertModal'
import { isActiveBoolean } from 'src/redux/actions/changeisActiveAction'
import { setProductTablePaginationData } from 'src/redux/slices/productSlice'
import StatusButton from 'src/app/pages/orders/StatusButton'
import useAppToast from 'src/hooks/useAppToast'
import moment from 'moment'
import LinkButtonGroup from '../LinkButtonGroup'
import ProductLinkStatusTab from '../ProductLinkStatusTab'
import {formatChannelLabel} from '../linkingStatusUtils'
import BulkProductLinking from '../BulkProductLinking'
import { formatDateLocal, formatTimeZone } from 'src/utils/TimeZoneDateFormat'
import './Products.css'
import { currencySigns, loggedInAdminAccessToken } from 'src/utils/constants'
import { checkDynamicSettingPair } from 'src/utils/checkDynamicSettingPair'
import { useUserHavingWriteAccess } from 'src/utils/useUserHavingWriteAccess'
import { isListingProductBulkActionPlatform, getListingProductBulkActionOptions } from 'src/utils/listingProductBulkActions'
import { isListingProductUploadPlatform } from 'src/utils/listingProductUploadPlatforms'
import { usePermission } from 'src/hooks/usePermission'
import { deleteProductAsync, deleteVariantAsync, getAgProductColumnsAsync, getListingAgProductsAsync } from 'src/redux/actions/omsProductActions'
import UploadCsvModal from 'src/app/pages/create-product/UploadCsvModal'
import GroupedTableProducts from './GroupedTableProducts'
import { GroupedViewLite } from 'src/app/features/listing-product-table-lite/GroupedViewLite'
import GroupedViewLiteContainer from 'src/app/features/listing-product-table-lite/pages/GroupedViewLiteContainer'

const CommonColumn: FC<{ rowData: string }> = ({ rowData }) => {
  return (
    <> <p>{rowData}</p>
    </>
  )
}

const ProductNameWithLink: FC<{ rowData: any }> = ({ rowData }) => {
  const params = useParams()

  return (
    <div>
      <Link className='fw-bold text-info mb-0 text-decoration-none'
        to={`/product-variant-detail/${rowData?.id}/platform/${rowData?.platform_product?.platform}/product/${rowData?.platform_product?.id}/${params.platformId}`}
      ><h5 className='text-start mb-0 text-preserve-spacing'>{rowData?.platform_product?.name + ' '}</h5>
      </Link>
      <small className='fw-bold'>
        {(rowData?.name == 'Default Title' || rowData?.name === rowData?.platform_product?.name || rowData?.name === "") ? '' : 'Variant : ' + rowData?.name}
      </small>
    </div>
  )
}

const ProductsTable: FC = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate();
  const { isRead, isWrite, isDelete } = usePermission();
  const { fetchedConnectedPlatformData } = useAppSelector((state) => state.fetchConnectedPlatform)
  const [showSettingsModal, setShowSettingsModal] = useState(false)
  const [showModal, setShowModal] = useState(false)
  const [mainStore, setMainStore] = useState(false)
  const [accountingStore, setAccountingStore] = useState(false)
  const [shippingStore, setShippingStore] = useState(false)
  const [erpStore, setErpStore] = useState(false)
  const [omsStore, setOmsStore] = useState(false)
  const [tooltipClosed, setTooltipClosed] = useState(false)
  const [platformData, setPlatformData] = useState<PlatformDataType | null>(null)
  const [currentPlatformId, setCurrentPlatformId] = useState<any>()
  const [paginationData, setPaginationData] = useState({
    page: 1,
    limit: 10,
    search_string: '',
    sort_by: '',
    sort_order: '',
  })
  const itemsPerPage = 10 // Adjust as needed
  const [linkingCompleted, setLinkingCompleted] = useState(false)
  const [searchTerm, setSearchTerm] = useState('')
  const [matchedParentProduct, setMatchedParentProduct] = useState<any | null>(null)
  const [dataFetched, setDataFetched] = useState(false)
  const [clickedRowIndex, setClickedRowIndex] = useState<number | null>(null)
  const [showUploadModal, setShowUploadModal] = useState(false)
  const [showBulkProductLinkingModal, setShowBulkProductLinkingModal] = useState(false)
  const [csvFile, setCSVFile] = useState<File | null>(null)
  const [platformModalId, setPlatformModalId] = useState<string>('')
  const [search_string, setSearch_string] = useState('')
  const [openConnectConfirmation, setOpenConnectConfirmation] = useState(false)
  const { connectedPlatformData } = useAppSelector((state) => state.connectedPlatform)
  const [currentId, setCurrentId] = useState<string | null>(null)
  const [selectSyncStatus, setSelectSyncStatus] = useState<{ [key: string]: string }>({});
  const { successToast, errorToast } = useAppToast()
  const [paginationMainData, setPaginationMainData] = useState({
    page: 1,
    limit: 10,
    search_string: '',
  })
  const [tablePage, setTablePage] = useState(1)
  const [showRefreshModal, setShowRefreshModal] = useState<boolean>(false)
  const [refreshPlatformId, setRefreshPlatformId] = useState<number | null>(null)
  const [refreshing, setRefreshing] = useState(false)
  const [selectedItemForActions, setSelectedItemForActions] = useState<number[]>([])
  const [opnDelistModal, setOpnDelistModal] = useState(false)
  const [isDelistIng, setIsDelistIng] = useState(false)
  const [selectedAction, setSelectedAction] = useState('')
  const { id, platformId } = useParams()
  const [currentChannelData, setcurrentChannelData] = useState<PlatformProductMappingData | null>(null)
  const [tabsData, setTabsData] = useState([])
  const [activeTab, setActiveTab] = useState<any>(null)
  const [connectedPlatformsTypewise, setConnectedPlatformsTypewise] = useState<string[]>([]);
  const { fetchedUserAccountLoading, fetchedUserAccountData } = useAppSelector((state) => state.userAccountData)
  const isUserStaff = fetchedUserAccountData?.account_type === 'USER_STAFF'
  const accountType = fetchedUserAccountData?.account_type;

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState<any>(null);

  const [isDeleting, setIsDeleting] = useState(false);
  const [deletingId, setDeletingId] = useState<number | null>(null);

  const canShowCreateAndActions = (fetchedConnectedPlatformData || []).find((obj: any) => obj.id === Number(id))?.isOmsStore ?? false;

  const [showOmsProductUploadModal, setShowOmsProductUploadModal] = useState(false);
  const [activeView, setActiveView] = useState<'grouped' | 'flat' | 'grouped-lite'>('flat')
  const [clickedGroupedLiteRow, setClickedGroupedLiteRow] = useState<any | null>(null)
  console.log("fetchedConnectedPlatformData", fetchedConnectedPlatformData)
  console.log("platformId", id, platformId)

  const handleCreate = () => {
    navigate("/create-product", { state: { mode: "create", rowData: undefined, platformId: Number(id) } });
  };

  const handleUploadModalOpen = () => {
    setShowUploadModal(true);
  };

  const handleUploadModalClose = () => {
    setShowUploadModal(false);
  };

  const [filters, setFilters] = useState({});
  const { isUserHavingWriteAccess } = useUserHavingWriteAccess();
  // Handle click event from LinkButton
  const ResyncButton = ({ productId }) => {
    const handleResyncClick = async () => {
      try {
        // Dispatch your API call action here, passing the orderId
        dispatch(productVarientResyncAsync({ failed_variant_ids: [productId] })).then((response) => {
          if (id) {
            dispatch(
              getAllProductsVarientsFromChannelAsync({ id: id, paginationdata: { ...productTablePaginationData }, }))
            // Show toast notification after successful dispatch
          }
          successToast('Failed Product resyncing started, status changed to Pending')
        })
      } catch (error) {
        console.error('Error during order resync:', error)
        toast.error('Order resync failed. Please try again.')
      }
    }

    return (
      <Fragment>
        <OverlayTrigger placement='top'
          overlay={
            <Tooltip id={`tooltip-${productId}`}>Click to resync the product variant</Tooltip>
          }
        >
          <Button className='ms-2 p-2 px-3 ' variant='link' style={{ cursor: 'pointer' }} onClick={handleResyncClick}
          ><FontAwesomeIcon icon={faRotate} color='red' size='lg' />
          </Button>
        </OverlayTrigger>
      </Fragment>
    )
  }

  const handleIconClick = (rowIndex) => {
    // Use the rowIndex here
    setShowModal(true)
    setClickedRowIndex(rowIndex)
  }

  useEffect(() => {
    handleResetFilters()
  }, [id, platformId])


  const productVariantSlice = useAppSelector((state) => state.productVarientsOfSingleChannel)

  const { productTablePaginationData, reset } = useAppSelector(
    (state) => state.productsOfSingleChannel
  )

  const productVarientsFromMainChannel = useAppSelector((state) => state.productVarientFromMain)
  const { connectedPlatformTypes, connectedPlatformTypesLoading } = useAppSelector(
    (state) => state.fetchConnectedPlatform
  )
  // const {mainStoreData, accountingStoreData} = useAppSelector((state) => state.fetchConnectedPlatform)
  // const accountingStoreId = useAppSelector((state) => state.fetchConnectedPlatform.accountingStoreData?.id)
  //   const shippingStoreId = useAppSelector((state) => state.fetchConnectedPlatform.shippingStoreData?.id)

  useEffect(() => {
    dispatch(
      getListingAgProductsAsync({
        platformId: Number(id),
        page: 1,
        limit: 10,
        sort_by: "",
        sort_order: "",
        search_string: "",
      })
    );

    dispatch(
      getAgProductColumnsAsync({
        platformId: Number(id),
        page: 1,
        limit: 10,
      })
    );
  }, []);

  useEffect(() => {
    dispatch(getAllPlatformTypesAsync({ platform_id: id! })).then((res: any) => {
      const { data, self_data } = res?.payload
      const main = Boolean(self_data?.isMainStore)
      const accounting = Boolean(self_data?.isAccountingStore)
      const shipping = Boolean(self_data?.isShippingStore)
      const erp = Boolean(self_data?.isErpStore)
      const oms = Boolean(self_data?.isOmsStore)

      setMainStore(main)
      setAccountingStore(accounting)
      setShippingStore(shipping)
      setErpStore(erp)
      setOmsStore(oms)

      setTabsData(data)
      setcurrentChannelData(res?.payload)
      if (res?.payload?.data?.length > 0) {
        setActiveTab(res.payload.data[0].id)
      }
      const platformTypes = Array.isArray(data) ? data.map((item) => item.name) : [];
      setConnectedPlatformsTypewise(platformTypes)
    })
  }, [id])

  useEffect(() => {
    if (showModal) {
      return
    }
    const self_data = connectedPlatformTypes?.self_data
    if (!self_data || !id) {
      return
    }
    const channel_id = self_data?.id
    const isAccountingStore = Boolean(self_data?.isAccountingStore)
    const isShippingStore = Boolean(self_data?.isShippingStore)
    const isMainStore = Boolean(self_data?.isMainStore)
    const isErpStore = Boolean(self_data?.isErpStore)
    if (!(isAccountingStore || isShippingStore || isMainStore || isErpStore)) {
      return
    }
    if (channel_id !== Number(id)) {
      return
    }
    try {
      dispatch(
        getAllProductsVarientsFromChannelAsync({ id: String(channel_id), paginationdata: productTablePaginationData, }))
    } catch (err) {
      console.error('Error fetching platform data:', err)
    }
  }, [id, connectedPlatformTypes, productTablePaginationData, linkingCompleted, showModal])

  useEffect(() => {
    if (!showModal || !activeTab) {
      return
    }
    try {
      dispatch(getAllProductsVarientsFromMainChannelAsync({ id: String(activeTab), paginationdata: paginationMainData, }))
    } catch (err) {
      console.error('Error fetching platform data:', err)
    }
  }, [showModal, activeTab, paginationMainData])

  const handlePagination = (pageNumber) => {
    setPaginationMainData((pre) => {
      return { ...pre, page: pageNumber }
    })
  }

  const clickedProductVariant: any = clickedGroupedLiteRow ?? (clickedRowIndex !== null && clickedRowIndex >= 0 &&
    clickedRowIndex < productVariantSlice.productVarientsOfSingleChannel.length
    ? productVariantSlice.productVarientsOfSingleChannel[clickedRowIndex] : null)

  const { name, sku, platform_product: { name: platformProductName = '', image_set: [productImage] = [] } = {},
  } = clickedProductVariant || {}

  const handleClose = () => {
    setShowModal(false)
    setMatchedParentProduct(null) // Reset matched product details when modal is closed
    setSearchTerm('')
    setOpenConnectConfirmation(false)
    setClickedGroupedLiteRow(null)
    setPaginationMainData({
      limit: 10,
      page: 1,
      search_string: '',
    })
  }

  const handleLinkProductVariant = (activeTab) => {
    if (matchedParentProduct && clickedProductVariant && clickedProductVariant.id) {
      setLinkingCompleted(true) // Set linking completion state to true

      const selectedChannel: any = tabsData.find((item: any) => item.id === Number(activeTab))
      const channelType = String(selectedChannel?.type || '').toLowerCase()

      const selected_channel_key: Record<string, string> = {
        primary: 'parent_variant_id',
        oms: 'oms_parent_variant_id',
        accounting: 'accounting_parent_variant_id',
        shipping: 'shipping_parent_variant_id',
        erp: 'erp_parent_variant_id',
        erp_secondary: 'erp_secondary_parent_variant_id',
      }
      const payload: any = {
        variant_id: clickedProductVariant?.id,
      };

      const key = selected_channel_key[channelType];

      if (key && matchedParentProduct?.id) {
        payload[key] = matchedParentProduct.id;
      }
      dispatch(
        linkProductVarientAsync(payload)
      ).then((response: any) => {
        const successMessage = response?.payload?.message || response?.payload?.data?.message
        const errorMessage =
          response?.payload?.data?.message ||
          response?.payload?.data?.error ||
          response?.payload?.message

        if (linkProductVarientAsync.fulfilled.match(response)) {
          toast.success(successMessage || 'Product Listing Linked Successfully')
          handleClose() // Close the modal
          return
        }

        errorToast(errorMessage || 'Failed to link product')
      })
        .catch(() => {
          errorToast('Failed to link product')
        })
        .finally(() => {
          setLinkingCompleted(false)
        })
    } else {
      console.log('Please select a product before linking.')
    }
  }

  const handleCloseTooltip = () => {
    //
    setTooltipClosed(false)
  }

  useEffect(() => {
    const getProductVarientsOfChannel = () => {
      try {
        if (id && !showModal) {
          setCurrentId(id)
          // alert(paginationData.page)
          dispatch(
            getAllProductsVarientsFromChannelAsync({
              id: id,
              paginationdata: { ...productTablePaginationData },
            })
          )
        }
      } catch (err) {
        console.error('Error fetching platform data:', err)
      }
    }
    // Call the fetchData function
    const self_data = connectedPlatformTypes?.self_data
    if (self_data) {
      const channel_id = self_data?.id
      const isAccountingStore = Boolean(self_data?.isAccountingStore)
      const isShippingStore = Boolean(self_data?.isShippingStore)
      const isMainStore = Boolean(self_data?.isMainStore)
      const isErpStore = Boolean(self_data?.isErpStore)
      if (
        !isAccountingStore &&
        !isShippingStore &&
        !isMainStore &&
        !isErpStore &&
        channel_id === Number(id)
      ) {
        getProductVarientsOfChannel()
      }
    }
  }, [id, productTablePaginationData, connectedPlatformTypes, linkingCompleted,])

  useEffect(() => {
    if (Object.keys(filters).length > 0) {
      const updatedData = {
        page: 1,
        ...filters,
      };
      dispatch(setProductTablePaginationData(updatedData));
    }
  }, [filters]);

  useEffect(() => {
    dispatch(
      setProductTablePaginationData({
        page: 1, sync_status: '', search_string: '', accounting_sync_status: '', shipping_sync_status: '',
        erp_sync_status: '', erp_secondary_sync_status: '',
      }))
    setFilters({})
  }, [id])

  useEffect(() => {
    if (!showModal) {
      setTablePage(productTablePaginationData.page)
    }
  }, [productTablePaginationData.page, showModal])

  const isTiktokPlatform =
    (currentChannelData?.self_data?.name || '').toUpperCase() === 'TIKTOK'

  const columns1: any = [
    {
      name: 'Product Name',
      cell: (row) => <ProductNameWithLink rowData={row} />,
      sortable: true,
      grow: 2,
      width: '220px',
      sortField: 'name',
      left: true,
      style: { paddingLeft: '20px' }, // Add left padding to adjust starting position
      headerStyle: { textAlign: 'center' },
      // cellStyle: {textAlign: 'right'}, // Align cell content to the left
    },
    {
      name: 'Status',
      cell: (row) => (
        <p
          className='badge badge-success py-2 fs-6'
          style={{ color: 'white', borderRadius: '5px', border: 'none', cursor: 'pointer', width: '130px', }}
        >{row?.platform_product?.api_status
          ? row?.platform_product?.api_status[0].toUpperCase() +
          row?.platform_product?.api_status.slice(1) : '-'}
        </p>
      ),
      // sortable: true,
      right: true,
      // width: '100px',
      center: true,
    },

    {
      name: 'Channel SKU',
      cell: (row) => <CommonColumn rowData={row.sku} />,
      // sortable: true,
      width: '140px',
      center: true
    },
    ...(isTiktokPlatform
      ? [{
        name: 'SKU Id',
        cell: (row) => <CommonColumn rowData={row?.api_id ? String(row.api_id) : '-'} />,
        width: '140px',
        center: true,
      },] : []),
    {
      name: 'Inventory Level',
      cell: (row) => <CommonColumn rowData={row?.quantity} />,
      // sortable: true,
      right: true,
      width: '140px',
      center: true,
    },
    {
      name: 'Price',
      cell: (row) => {
        const { price } = row
        const primaryCurrency = price?.currency_iso ?? platformData?.currency_iso;
        const currencySymbol = currencySigns[primaryCurrency!] ?? '$';
        const formattedValue = price?.value ? Number(price.value).toFixed(2) : '0.00';

        return <CommonColumn rowData={`${currencySymbol} ${formattedValue}`} />
      },
      // sortable: true,
      right: true,
      // width: '100px',
      center: true,
      sortField: 'price',
    },
    {
      name: 'Barcode',
      cell: (row) => <CommonColumn rowData={row.barcode} />,
      // sortable: true,
      width: '160px',
      center: true,
    },
    {
      name: (
        <>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "6px" }}>
            <span>Created At</span>{' '}
            <OverlayTrigger placement="top"
              overlay={<Tooltip>{formatTimeZone()}</Tooltip>}>
              <span style={{ cursor: 'pointer' }}>
                <FontAwesomeIcon icon={faInfoCircle} />
              </span>
            </OverlayTrigger>
          </div>
        </>
      ),
      cell: (row) => {

        return (
          <CommonColumn
            rowData={
              row?.created_at ? formatDateLocal(row.created_at) : ''
            }
          />
        );
      },
      // sortable: true,
      right: true,
      width: '160px',
      center: true,
    },
    {
      name: (
        <>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "6px" }}>
            Updated At{' '}
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip>{formatTimeZone()}</Tooltip>}
            >
              <span style={{ cursor: 'pointer' }}>
                <FontAwesomeIcon icon={faInfoCircle} />
              </span>
            </OverlayTrigger>
          </div>
        </>
      ),
      cell: (row) => {

        return (
          <CommonColumn
            rowData={
              row?.updated_at
                ? formatDateLocal(row.updated_at)
                : ''
            }
          />

        );
      },
      right: true,
      width: '160px',
      center: true,
    }
    // {
    //   name: 'Last Updated',
    //   cell: (row) =>row?.updated_at
    //         ? moment.utc(row?.updated_at).format('hh:mm A, DD-MM-YYYY')
    //         : '',
    //   sortable: true,
    //   width: '180px',
    // },
    // {
    //   name: 'Title & Des Tmpl',
    //   cell: (row) => <CommonColumn rowData={'row.titleDesTmpl'} />,
    //   sortable: true,
    //   width: '160px',
    // },
    // {
    //   name: 'Category Tmpl',
    //   cell: (row) => <CommonColumn rowData={'row.categoryTmpl'} />,
    //   sortable: true,
    //   width: '160px',
    // },
  ]

  const columnsRange: any = [
    {
      name: 'Product Name',
      cell: (row) => <ProductNameWithLink rowData={row} />,
      sortable: true,
      grow: 2,
      width: '240px',
      sortField: 'name',
      left: true, // Align header text to the center
      // Add left padding to adjust starting position
      headerStyle: { paddingLeft: '50px' }, // Align header text to the center
    },

    ...((mainStore || erpStore)
      ? [
        {
          name: 'Status',
          cell: (row) => (
            <div className="badge badge-success py-1 fs-6">
              {row?.platform_product?.api_status
                ? row?.platform_product?.api_status[0].toUpperCase() +
                row?.platform_product?.api_status.slice(1)
                : '-'}
            </div>
          ),
          center: true,
          // sortable: true,
          // width: '100px',
        },
      ]
      : []),
    // {
    //   name: 'Sync Status',
    //   cell: (row) =>
    //     row ? (
    //       row?.sync_status === 'PROCESSING'|| 
    //       row?.sync_status === 'ERROR' ||
    //       row?.sync_status === 'ERROR_UNLINKED'  ? (
    //         <div className='d-flex '>
    //           <StatusButton syncStatus={row?.sync_status} syncMessage={row?.sync_message} />

    //           <ResyncButton
    //             productId={row.id}
    //             // Implement the onResyncClick function to handle resync logic
    //           />
    //         </div>
    //       ) : (
    //         <StatusButton syncStatus={row?.sync_status} syncMessage={row?.sync_message} />
    //       )
    //     ) : null,
    //   // sortable: true,
    //    minWidth:'220px',
    //   center: true,
    //   // width: process.env.REACT_APP_ENV === 'staging' ? '200px' : '0px', // Set width conditionally
    //   // style: {display: process.env.REACT_APP_ENV === 'staging' ? 'block' : 'none'}, // Set display style conditionally
    // },
    {
      name: 'Channel SKU',
      cell: (row) => <CommonColumn rowData={row?.sku} />,
      minWidth: '120px',
      // sortable: true,
    },
    ...(isTiktokPlatform
      ? [
        {
          name: 'SKU Id',
          cell: (row) => <CommonColumn rowData={row?.api_id ? String(row.api_id) : '-'} />,
          minWidth: '120px',
          center: true,
        },
      ]
      : []),
    {
      name: 'Inventory Level',
      cell: (row) => <CommonColumn rowData={row?.quantity} />,
      // sortable: true,
      right: true,
      width: '135px',
      center: true,
    },
    {
      name: 'Price',
      cell: (row) => {
        const { price } = row
        const primaryCurrency = price?.currency_iso ?? platformData?.currency_iso;
        const currencySymbol = currencySigns[primaryCurrency!] ?? '$';
        const formattedValue = price?.value ? Number(price.value).toFixed(2) : '0.00';

        return <CommonColumn rowData={`${currencySymbol} ${formattedValue}`} />
      },
      // sortable: true,
      right: true,
      width: '100px',
      center: true,
      sortField: 'price',
    },
    {
      name: 'Barcode',
      cell: (row) => <CommonColumn rowData={row?.barcode} />,
      width: '160px',
    },
    {
      name: (
        <>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "6px" }}>
            <span>Created At</span>{' '}
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip>{formatTimeZone()}</Tooltip>}
            >
              <span style={{ cursor: 'pointer', color: 'darkgray' }}>
                <FontAwesomeIcon icon={faInfoCircle} />
              </span>
            </OverlayTrigger>
          </div>
        </>
      ),
      cell: (row) => {
        return (

          <CommonColumn
            rowData={row?.created_at ? formatDateLocal(row.created_at) : ''}
          />
        );
      },
      right: true,
      width: '160px',
      center: true,
    },
    {
      name: (
        <>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "6px" }}>
            Updated At{' '}
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip>{formatTimeZone()}</Tooltip>}
            >
              <span style={{ cursor: 'pointer', color: 'darkgray' }}>
                <FontAwesomeIcon icon={faInfoCircle} />
              </span>
            </OverlayTrigger>
          </div>
        </>
      ),
      cell: (row) => {
        return (
          <CommonColumn
            rowData={
              row?.updated_at
                ? formatDateLocal(row.updated_at)
                : ''
            }
          />
        );
      },
      right: true,
      width: '160px',
      center: true,
    },
  ]

  if (tabsData?.length > 0) {
    columnsRange.splice(1, 0,
      {
        name: (
          <span
            className='link-status-icon MuiSvgIcon-root MuiSvgIcon-colorPrimary'
            style={{ marginRight: '5px' }}
            title='Shows if the Products between the channel are linked or not'
          >
            Linking Status
          </span>
        ),
        cell: (row, rowIndex) => (
          <div>
            <ProductLinkStatusTab
              data={row}
              channels={tabsData}
            />
          </div>
        ),
        width: '150px',
        center: true,
      },
      {
        name: (
          <span
            className='link-status-icon MuiSvgIcon-root MuiSvgIcon-colorPrimary'
            style={{ marginRight: '5px' }}
            title='Shows if the Products between the channel are linked or not'
          >
            Link Actions
          </span>
        ),
        cell: (row, rowIndex) => (
          <div>
            <LinkButtonGroup
              rowData={row}
              rowIndex={rowIndex}
              onClick={handleIconClick}
              onCloseTooltip={handleCloseTooltip}
              platformId={platformId}
              mainStore={mainStore}
              erpStore={erpStore}
              channels={tabsData}
            />
          </div>
        ),
        width: '150px',
        center: true,
      },
    )
  }

  const FilterDropdown = ({ filters, setFilters, options, hasActiveFilter }) => {
    const [show, setShow] = useState(false);
    const iconRef = useRef(null);

    const handleSelectChange = (e, key) => {
      setFilters((prev) => ({
        ...prev,
        [key]: e.target.value,
      }));
    };

    return (
      <>
        <span
          ref={iconRef}
          style={{
            cursor: "pointer",
            color: hasActiveFilter ? "blue" : "darkgrey",
          }}
          onClick={() => setShow(!show)}
        >
          <FontAwesomeIcon icon={faFilter} />
        </span>

        <Overlay
          target={iconRef.current}
          show={show}
          placement="bottom-end"
          rootClose
          onHide={() => setShow(false)}
        >
          <Popover id="filter-popover" className="p-2" style={{ minWidth: "220px" }}>
            <Popover.Body>
              {options.map(({ label, key, values }) => (
                <Form.Group key={key} className="mb-2">
                  <Form.Label className="mb-1">{label}</Form.Label>
                  <Form.Select
                    size="sm"
                    value={filters[key] || ""} // ✅ controlled by parent
                    onChange={(e) => handleSelectChange(e, key)}
                  >
                    <option value="">All</option>
                    {values.map((val, idx) => (
                      <option key={idx} value={val.value}>
                        {val.name}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              ))}
            </Popover.Body>
          </Popover>
        </Overlay>
      </>
    );
  };

  const handleEditProductVariant = (row: any) => {
    console.log('handleEditProductVariant called with row:', row);
    
    // If the product specifically has no options (variants), route to product edit page instead
    if (row?.has_options === false || row?.platform_product?.has_options === false) {
      navigate(`/update-product/platform/${Number(id)}/productId/${row?.platform_product?.id}`, { state: { mode: "edit", rowData: row, platformId: Number(id) } });
    } else {
      navigate(`/update-variant/platform/${Number(id)}/productId/${row?.platform_product?.id}/variantId/${row?.id}`, { state: { mode: "edit", rowData: row, platformId: Number(id) } });
    }
  };

  const handleDeleteConfirm = async () => {
    if (!selectedProduct) return;
    const productId = Number(selectedProduct?.platform_product?.id);
    const variantId = Number(selectedProduct?.id);

    try {
      if (variantId) {
        setIsDeleting(true);
        setDeletingId(variantId);

        const response = await dispatch(deleteVariantAsync({ productId: productId, variantId: variantId, })).unwrap();

        // success for 200 or 201
        if (response?.status === 200 || response?.status === 201) {
          toast.success(response?.message || "Product deleted successfully");
        } else {
          toast.error(response?.message || "Failed to delete product");
        }

        dispatch(
          getAllProductsVarientsFromChannelAsync({ id: String(id), paginationdata: { ...productTablePaginationData }, })
        );
      }
    } catch (error: any) {
      toast.error(error?.data?.message || error?.data?.errors?.detail || error?.message ||
        'Delete failed'
      )
      console.error('Delete failed:', error)
    } finally {
      setIsDeleting(false);
      setDeletingId(null);
      setShowDeleteModal(false);
      setSelectedProduct(null);
    }
  };

  const handleDeleteClick = (row: any) => {
    if (isDeleting) return; // extra safety

    setSelectedProduct(row);
    setShowDeleteModal(true);
  };

  const handleDeleteCancel = () => {
    if (isDeleting) return; // prevent closing mid-delete (optional)

    setShowDeleteModal(false);
    setSelectedProduct(null);
  };

  const columns = useMemo(() => {
    const base = [...columnsRange];
    const channel_wise_dynamic_columns = Array.isArray(tabsData) ? tabsData?.map((item: any) => {
      const typeKey = item?.type === 'primary' ? 'sync_status' : `${item.type}_sync_status`;

      return {
        name: (
          <>
            <span className="me-2">{`${formatChannelLabel(item.type)} Sync Status`}</span>

            <FilterDropdown
              filters={filters}
              setFilters={setFilters}
              options={[
                {
                  label: "Filter Status",
                  key: typeKey,
                  values: [
                    { name: "SYNCED", value: "LINKED" },
                    { name: "PENDING", value: "PENDING" },
                    { name: "CREATED", value: "CREATED" },
                    { name: "ERROR", value: "ERROR" },
                    { name: "PROCESSING", value: "PROCESSING" },
                    { name: "DELISTED", value: "DELISTED" },
                  ],
                },
              ]}
              hasActiveFilter={!!productTablePaginationData?.[typeKey]}
            />


          </>
        ),
        cell: (row) => {
          if (!row) return null;

          const syncStatus = item.type === 'primary' ? row.sync_status : row[`${item.type}_sync_status`];
          const syncMessage = item.type === 'primary' ? row.sync_message : row[`${item.type}_sync_message`];

          if (syncStatus === 'PROCESSING' || syncStatus === 'ERROR' || syncStatus === 'ERROR_UNLINKED') {
            return (
              <div className='d-flex align-items-center'>
                <StatusButton syncStatus={syncStatus} syncMessage={syncMessage} />
                <ResyncButton productId={row.id} />
              </div>
            );
          }

          return <StatusButton syncStatus={syncStatus} syncMessage={syncMessage} />;
        },
        minWidth: '220px',
        center: true,
      };
    }) : [];

    // Insert dynamic columns after index 5:
    base.splice(5, 0, ...(channel_wise_dynamic_columns ?? []));

    // Add Actions column at the end (or wherever you want)
    if (canShowCreateAndActions) {
      base.push({
        name: "Actions",
        cell: (row: any) => {
          const rowId = Number(row?.platform_product?.id);
          const isThisRowDeleting = isDeleting && deletingId === rowId;
          const isCreatedByCommercium = row?.isCreatedByCommercium === true;

          return isCreatedByCommercium ? (
            <div className="d-flex gap-2 justify-content-center">
              {isWrite && (
                <button
                  type="button"
                  className="btn btn-sm btn-light-primary"
                  disabled={isDeleting}
                  onClick={() => handleEditProductVariant(row)}
                >
                  <KTIcon iconName="pencil" className="fs-4" />
                </button>
              )}

              {isDelete && (
                <button
                  type="button"
                  className="btn btn-sm btn-light-danger"
                  disabled={isDeleting}
                  onClick={() => handleDeleteClick(row)}
                >
                  {isThisRowDeleting ? (
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    />
                  ) : (
                    <KTIcon iconName="trash" className="fs-4" />
                  )}
                </button>
              )}
            </div>
          ) : null;
        },
        minWidth: "160px",
        center: true,
        ignoreRowClick: true,
        allowOverflow: true,
        button: true,
      });
    }
    return (accountingStore || shippingStore || erpStore || (omsStore && !(tabsData?.length > 0))) ? columns1 : base;
  }, [tabsData, productTablePaginationData]);

  // Function to open the CSV upload modal
  const handleOpenUploadModal = () => {
    setShowUploadModal(true)
    setPlatformData(currentChannelData?.self_data);
    if (id) {
      setPlatformModalId(id)
    }
  }

  const handleCloseUploadModal = () => {
    setShowUploadModal(false)
  }

  const handleOpenBulkProductLinkingModal = () => {
    setShowBulkProductLinkingModal(true)

    if (id) {
      setPlatformModalId(id)
    }
  }

  const handleCloseBulkProductLinkingModal = () => {
    setShowBulkProductLinkingModal(false)
  }

  const handleSort = (ev, sortDirection) => {
    dispatch(
      setProductTablePaginationData({
        sort_by: ev.sortField,
        sort_order: (sortDirection + '').toUpperCase(),
        sync_status: selectSyncStatus,
      })
    )
    // setPaginationData((pre) => {
    //   return {...pre, sort_by: ev.sortField, sort_order: (sortDirection + '').toUpperCase()}
    // })
  }

  const handleResetFilters = () => {
    setSelectSyncStatus({});
    dispatch(
      setProductTablePaginationData({
        page: 1,
        sync_status: '',
        search_string: '',
        accounting_sync_status: '',
        shipping_sync_status: '',
        erp_sync_status: '',
        erp_secondary_sync_status: '',
      })
    )
    setSearch_string('')
    setFilters({})
  }

  const calculateVisibleRecordRange = ({ page, limit }) => {
    const count = productVarientsFromMainChannel.ProductVarientCountFromMainChannel
    const startRecord = (page - 1) * limit + 1;
    const endRecord = Math.min(page * limit, count);
    return { startRecord, endRecord };
  };
  // Product Record range for each paginated section
  const productRecordRange = calculateVisibleRecordRange(paginationMainData);
  const isLoading = productVariantSlice.loadingProductVarientsFromChannel

  return (
    <>
      {currentChannelData?.self_data?.id === Number(id) && (
        <>
          <div className='product-table-container  mb-3'>
            <div className='d-flex flex-row flex-wrap justify-content-between mb-3'>
              <div className='d-flex flex-row flex-wrap'>
                <div className='d-flex align-items-center'>
                  <span className='fw-bold text-lg' style={{ fontSize: '16px' }}>
                    {mainStore
                      ? 'Source Store Product'
                      : erpStore
                        ? 'ERP Store Product'
                        : accountingStore
                          ? 'Accounting Store Product'
                          : shippingStore
                            ? 'Shipping Store Product'
                            : omsStore
                                ? 'Master Products'
                                : 'Destination Store Product'}
                  </span>
                  <span className='ms-2 fw-bold text-lg' style={{ fontSize: '16px' }}>
                    - {currentChannelData?.self_data?.display_name || currentChannelData?.self_data?.name}
                  </span>
                </div>
              </div>
              <div>
                {/* <div className='ms-2  pe-2 mb-3'>
              {displayName === 'The Range' && (
                <button
                  className='btn  me-4 ms-10 btn-primary btn-sm d-inline-flex'
                  onClick={handleOpenUploadModal}
                >
                  <div className='me-2' style={{fontSize: '14px'}}>
                    <FontAwesomeIcon icon={faFile} className='svg-icon-muted svg-icon-2hx' />
                  </div>
                  <div style={{fontSize: '14px'}}>Upload Product List</div>
                </button>
              )}

              <button
                className='btn btn-primary btn-sm d-inline-flex'
                onClick={handleOpenSettingsModal}
              >
                <div className='mt-1 me-2'>
                  <FontAwesomeIcon
                    icon={faCog}
                    className='svg-icon-muted svg-icon-2hx'
                    style={{fontSize: '14px'}}
                  />
                </div>
                <div style={{fontSize: '14px'}}>Settings</div>
              </button>
            </div> */}
                <div className='d-flex justify-content-sm-end ms-2 pe-2 mb-3 mt-2'>
                  {/* {currentChannelData?.is_product_mapping_allowed && 
              ( fetchedUserAccountData?.role &&  fetchedUserAccountData?.role?.customer_access === "WRITE" || (fetchedUserAccountData?.is_superuser || fetchedUserAccountData?.user_type ==="USER")) 
               */}
                  {/* {currentChannelData?.is_product_mapping_allowed && (
  fetchedUserAccountData?.role
    ? fetchedUserAccountData?.role?.customer_access === "WRITE"
    : fetchedUserAccountData?.is_superuser || fetchedUserAccountData?.user_type ==="USER"
)  */}
                  {(isWrite && currentChannelData?.is_product_mapping_allowed && isUserHavingWriteAccess()) && (
                    <button
                      className='btn btn-primary btn-sm d-inline-flex align-items-center me-2'
                      onClick={handleOpenBulkProductLinkingModal}
                      style={{ fontSize: '14px', padding: '0.25rem 0.5rem' }}
                    // disabled={fetchedUserAccountData?.role?.customer_access === "READ"}
                    >
                      <div className='me-2' style={{ fontSize: '14px' }}>
                        <i className='bi bi-file-earmark-arrow-up fs-4'></i>
                      </div>
                      <div style={{ fontSize: '14px' }}>Bulk Product Linking</div>
                    </button>
                  )}

                  {isListingProductUploadPlatform(currentChannelData?.self_data?.name) &&
                    isWrite && isUserHavingWriteAccess() && (
                      <button
                        className='btn btn-primary btn-sm d-inline-flex align-items-center me-2'
                        onClick={handleOpenUploadModal}
                        style={{ fontSize: '14px', padding: '0.25rem 0.5rem' }}
                      // disabled={fetchedUserAccountData?.role?.customer_access === "READ"}/
                      >
                        <div className='me-2' style={{ fontSize: '14px' }}>
                          <i className='bi bi-file-earmark-arrow-up fs-4'></i>
                        </div>
                        <div style={{ fontSize: '14px' }}>Product & Warehouse Upload</div>
                      </button>
                    )}

                  {/* {fetchedUserAccountData?.role &&
              (<>
                {fetchedUserAccountData?.role?.customer_access === "READ" 
                ?                 
                (
                  <div
                    className='btn btn-primary btn-sm d-inline-flex align-items-center'
                    style={{
                      fontSize: '14px',
                      padding: '0.25rem 0.5rem',
                      opacity: 0.5,
                      cursor: 'not-allowed',
                      pointerEvents: 'none',
                    }}
                  >
                    <div className='me-2' style={{fontSize: '14px'}}>
                      <FontAwesomeIcon icon={faCog} className='svg-icon-muted svg-icon-2hx' />
                    </div>
                    <div style={{fontSize: '14px'}}>Settings</div>
                  </div>
                ) : (
                    <Link
                      to={
                        (mainStore || accountingStore || shippingStore || erpStore) ? `/primary-platform-setting/${id}`
                        : 
                        checkDynamicSettingPair(connectedPlatformsTypewise, currentChannelData?.self_data?.name)
                          ? `/channel-settings/${platformId}/${id}`
                          : `/platform-setting/${id}`}
                      className='btn btn-primary btn-sm d-inline-flex align-items-center'
                      style={{ fontSize: '14px', padding: '0.25rem 0.5rem' }}
                  >
                    <div className='me-2' style={{fontSize: '14px'}}>
                      <FontAwesomeIcon icon={faCog} className='svg-icon-muted svg-icon-2hx' />
                    </div>
                    <div style={{fontSize: '14px'}}>Settings</div>
                  </Link>
                )}
              </>
              )} */}

                  {(canShowCreateAndActions && isWrite) && (
                    <div className="mx-md-2 my-1 my-md-0 gap-3">
                      <button
                        className="btn btn-sm btn-primary py-2"
                        onClick={handleCreate}
                      >
                        + Add Product
                      </button>
                    </div>
                  )}
                  {(canShowCreateAndActions && isWrite) && (
                    <div className="mx-md-2 my-1 my-md-0 gap-3">
                      <button
                        className="btn btn-sm btn-primary fw-bold py-2"
                        onClick={handleUploadModalOpen}
                      >
                        Upload CSV
                      </button>
                    </div>
                  )}

                  {(isWrite && isUserHavingWriteAccess()) && (
                    <Link
                      to={
                        mainStore || accountingStore || shippingStore || erpStore
                          ? `/primary-platform-setting/${id}` : checkDynamicSettingPair(
                            connectedPlatformsTypewise, currentChannelData?.self_data?.name
                          ) ? `/channel-settings/${platformId}/${id}` : `/platform-setting/${id}`
                      }
                      className='btn btn-primary btn-sm d-inline-flex align-items-center'
                      style={{ fontSize: '14px', padding: '0.25rem 0.5rem' }}
                    >
                      <div className='me-2' style={{ fontSize: '14px' }}>
                        <FontAwesomeIcon icon={faCog} className='svg-icon-muted svg-icon-2hx' />
                      </div>
                      <div style={{ fontSize: '14px' }}>Settings</div>
                    </Link>
                  )}

                  {/* {isUserHavingWriteAccess() ||
                    (localStorage.getItem(loggedInAdminAccessToken) && (
                      <button
                        className='btn btn-sm btn-primary d-inline-flex ms-2 me-sm-4'
                        style={{ fontSize: '14px' }}
                        onClick={() => {
                          setShowRefreshModal(true)
                          setRefreshPlatformId(Number(id))
                        }}
                      // disabled={fetchedUserAccountData?.role?.customer_access === "READ"}
                      >
                        <div className='me-2' style={{ fontSize: '14px' }}>
                          <FontAwesomeIcon
                            icon={faArrowsRotate}
                            className='svg-icon-muted svg-icon-2hx'
                          />
                        </div>
                        <div style={{ fontSize: '14px' }}>Refresh Data</div>
                      </button>
                    ))} */}
                </div>
              </div>
            </div>
          </div>

          <div className='mb-4'>
            <div
              className='d-flex align-items-center border-bottom'
              style={{ gap: '32px' }}
            >
              <button
                type='button'
                className='btn btn-link text-decoration-none px-0'
                onClick={() => setActiveView('flat')}
                style={{
                  color: activeView === 'flat' ? '#0d6efd' : '#6c757d',
                  borderBottom:
                    activeView === 'flat' ? '2px solid #0d6efd' : '2px solid transparent',
                  borderRadius: 0,
                  fontWeight: 600,
                }}
              ><label>All Products</label>
                {/* (Flat) */}
              </button>
              <button
                type='button'
                className='btn btn-link text-decoration-none px-0'
                onClick={() => setActiveView('grouped')}
                style={{
                  color: activeView === 'grouped' ? '#0d6efd' : '#6c757d',
                  borderBottom:
                    activeView === 'grouped' ? '2px solid #0d6efd' : '2px solid transparent',
                  borderRadius: 0,
                  fontWeight: 600,
                }}
              >
                Grouped View
              </button>
              <button
                type='button'
                className='btn btn-link text-decoration-none px-0'
                onClick={() => setActiveView('grouped-lite')}
                style={{
                  color: activeView === 'grouped-lite' ? '#0d6efd' : '#6c757d',
                  borderBottom:
                    activeView === 'grouped-lite' ? '2px solid #0d6efd' : '2px solid transparent',
                  borderRadius: 0,
                  fontWeight: 600,
                }}
              >
                Grouped View Lite
              </button>
            </div>
          </div>

          {activeView === 'flat' ? (
            <div className='card card-flush'>
              <div className='card-header'>
                <div className='card-title'>
                  <input
                    className='form-control mr-sm-2 input-sm '
                    type='search'
                    placeholder='Search'
                    aria-label='Search'
                    onChange={(ev) => {
                      setSearch_string(ev.target.value)
                    }}
                    onKeyDown={(ev) => {
                      if (ev.key == 'Enter') {
                        dispatch(
                          setProductTablePaginationData({
                            search_string: search_string,
                            page: 1,
                          })
                        )
                      }
                    }}
                    value={search_string}
                  />
                </div>

                <div className='card-toolbar'>
                  <div className='d-flex flex-md-row flex-column justify-content-md-end'>
                    {!mainStore &&
                      !erpStore &&
                      isListingProductBulkActionPlatform(
                        currentChannelData?.self_data?.name
                      ) && (
                        <select
                          className='form-select me-2'
                          aria-label='Select Action'
                          value={selectedAction}
                          onChange={(ev) => {
                            setSelectedAction(ev.target.value)
                            if (
                              ev.target.value === 'delist' ||
                              ev.target.value === 'relist' ||
                              ev.target.value === 'full_update'
                            ) {
                              setOpnDelistModal(true)
                            } else {
                              setOpnDelistModal(false)
                            }
                          }}
                        >
                          <option value={''}>Action</option>
                          {getListingProductBulkActionOptions(
                            currentChannelData?.self_data?.name
                          ).map((option) => (
                            <option
                              key={option.value}
                              value={option.value}
                              disabled={
                                Boolean(option.requiresSelection) &&
                                !selectedItemForActions.length
                              }
                            >
                              {option.label}
                            </option>
                          ))}
                        </select>
                      )}

                    <div className='mx-md-2 my-1 my-md-0'>
                      <button
                        className='btn btn-sm btn-primary w-100px fw-bold py-2'
                        onClick={handleResetFilters}
                      >
                        Reset Filters
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <TableLoadingShell loading={isLoading} minHeight="50vh">
                <DataTable
                  pagination
                  paginationServer
                  paginationTotalRows={
                    productVariantSlice.productVarientsCountOfSingleChannel
                  }
                  paginationDefaultPage={tablePage}
                  paginationPerPage={productTablePaginationData.limit}
                  onChangePage={(page) => {
                    if (showModal) {
                      return
                    }
                    setTablePage(page)
                    dispatch(
                      setProductTablePaginationData({
                        ...productTablePaginationData,
                        page,
                      })
                    )
                  }}
                  onChangeRowsPerPage={(perPage, page) => {
                    if (showModal) {
                      return
                    }
                    setTablePage(page)
                    dispatch(
                      setProductTablePaginationData({
                        ...productTablePaginationData,
                        limit: perPage,
                        page,
                      })
                    )
                    setTablePage(page)
                  }}
                  key={`producttable-${reset}-${tablePage}`}
                  fixedHeader={true}
                  columns={columns}
                  noDataComponent={
                    <div className='text-secondary'>
                      <h5>No records found</h5>
                    </div>
                  }
                  persistTableHead
                  progressPending={false}
                  selectableRowsNoSelectAll
                  onSort={handleSort}
                  selectableRows={
                    !mainStore &&
                    !erpStore &&
                    isListingProductBulkActionPlatform(
                      currentChannelData?.self_data?.name
                    )
                  }
                  onSelectedRowsChange={({ selectedRows }) => {
                    setSelectedItemForActions(
                      selectedRows.map((item: any) => item?.id)
                    )
                  }}
                  selectableRowsHighlight={true}
                  data={
                    mainStore || shippingStore || accountingStore || erpStore
                      ? productVariantSlice.productVarientsOfSingleChannel
                      : productVariantSlice.productVarientsOfSingleChannel
                  }
                  customStyles={{
                    table: {
                      style: {
                        height: '50vh',
                      },
                    },
                    headCells: {
                      style: { fontWeight: 'bold', fontSize: '14px' },
                    },
                    cells: {
                      style: {
                        padding: '10px',
                        borderBottom: '1px solid gainsboro',
                        fontWeight: 'bold',
                      },
                    },
                  }}
                />
              </TableLoadingShell>
            </div>
          ) : activeView === 'grouped' ? (
            <GroupedTableProducts
              id={id}
              platformId={platformId}
              currentChannelData={currentChannelData}
              mainStore={mainStore}
              accountingStore={accountingStore}
              shippingStore={shippingStore}
              erpStore={erpStore}
              canShowCreateAndActions={canShowCreateAndActions}
            />
          ) : (
            <GroupedViewLiteContainer
              id={id}
              platformId={platformId}
              currentChannelData={currentChannelData}
              mainStore={mainStore}
              accountingStore={accountingStore}
              shippingStore={shippingStore}
              erpStore={erpStore}
              tabsData={tabsData}
              onLinkClick={(rowData, rowIndex) => {
                setClickedGroupedLiteRow(rowData)
                setClickedRowIndex(rowIndex)
                setShowModal(true)
                setMatchedParentProduct(null)
                setSearchTerm('')
                setPaginationMainData({
                  page: 1,
                  limit: 10,
                  search_string: '',
                })
              }}
            />
          )}

          <div>
            <Modal size='lg' show={showModal} onHide={handleClose}>
              <Modal.Header closeButton>
                <Modal.Title>Find Matching Product</Modal.Title>
              </Modal.Header>
              <Modal.Body style={{ overflowY: 'scroll', minHeight: '500px', maxHeight: '500px' }}>
                <Tabs
                  activeKey={activeTab}
                  onSelect={(k) => {
                    setActiveTab(k)
                    setPaginationMainData({
                      limit: 10,
                      page: 1,
                      search_string: '',
                    })
                  }}
                  id='product-tab'
                  className='mb-3 custom-tabs-product'
                >
                  {Array.isArray(tabsData) &&
                    tabsData?.map((tab: any) => (
                      <Tab
                        eventKey={tab.id}
                        title={
                          <div className='d-flex flex-column align-items-center'>
                            <span>{tab.display_name || tab.name}</span>
                            <span className='fs-6'>{`(${tab.type})`}</span>
                          </div>
                        }
                        key={tab.id}
                      >
                        <div>
                          <div
                            className='d-flex align-items-center mx-1 px-1'
                            style={{ backgroundColor: 'aliceblue', border: '4px inset lightgray' }}
                          >
                            <span className='symbol-label m-3' style={{ backgroundImage: 'none' }}>
                              <img
                                src={
                                  productImage
                                    ? productImage.image_url
                                    : 'https://appconnect-images.s3.us-east-2.amazonaws.com/No_Image_Available.jpg'
                                }
                                alt='Product Image'
                                style={{ width: '50px', height: '50px' }}
                              />
                            </span>
                            <div>
                              <div>
                                <h4>
                                  {platformProductName + ' - '}
                                  <span className='text-secondary'>{`${name}` == 'Default Title' ? ' ' : `${name}`}{' '}</span>
                                </h4>

                                <h5>Variant_Sku: {`${sku}`}</h5>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className='d-flex justify-content-between mx-1 mt-3'>
                          <h5 className='text-secondary d-inline align-self-center'>
                            {`Search for an existing product of ${tab.display_name || tab.name} channel to link`}
                          </h5>
                          <div style={{ position: 'relative', width: '33%', marginBottom: '10px' }}>
                            <input
                              type='text'
                              className='form-control pr-5 custom-input'
                              placeholder='Enter Product Name or Store SKU'
                              value={searchTerm}
                              onChange={(ev) => {
                                setSearchTerm(ev.target.value)
                              }}
                              onKeyDown={(ev) => {
                                if (ev.key === 'Enter') {
                                  setPaginationMainData((pre) => {
                                    return { ...pre, search_string: searchTerm }
                                  })
                                }
                              }}
                              style={{ border: '2px solid lightgray' }}
                            />
                            <FontAwesomeIcon
                              icon={faMagnifyingGlass}
                              style={{
                                position: 'absolute', right: '15px', top: '50%',
                                transform: 'translateY(-50%)', color: 'gray', pointerEvents: 'none',
                              }}
                            />
                          </div>
                        </div>
                        {productVarientsFromMainChannel.loadingProductVarientFromMainChannel ? (
                          <div className='card-body d-flex justify-content-center align-items-center'>
                            <Loader variant="section" />
                          </div>
                        ) : productVarientsFromMainChannel.productVarientFromMainChannel
                          .length === 0 ? (
                          <div className='card-body d-flex justify-content-center align-items-center'>
                            <h5>No Items Found</h5>
                          </div>) : productVariantSlice.productVarientsOfSingleChannel.length ? (
                            productVarientsFromMainChannel.productVarientFromMainChannel.map(
                              (product: any, index) => (
                                <div
                                  key={index}
                                  className='product-item mx-1'
                                  style={{ cursor: 'pointer' }}
                                >
                                  <div className='border-bottom my-2 border-2'></div>

                                  <div className='d-flex align-items-center justify-content-start'>
                                    <div className='m-2 me-4'>
                                      <span
                                        className='symbol-label'
                                        style={{ backgroundImage: 'none' }}
                                      >
                                        {product.platform_product &&
                                          product.platform_product.image_set.length > 0 ? (
                                          <img
                                            src={product.platform_product.image_set[0].image_url}
                                            alt={`Product Image ${index}`}
                                            style={{ width: '50px', height: '50px' }}
                                          />
                                        ) : (
                                          <img
                                            src='https://appconnect-images.s3.us-east-2.amazonaws.com/No_Image_Available.jpg'
                                            alt='No Image Available'
                                            style={{ width: '50px', height: '50px' }}
                                          />
                                        )}
                                      </span>
                                    </div>
                                    <div className='d-flex justify-content-between w-100 align-items-center'>
                                      <div className='me-4 text-start'>
                                        <div>
                                          <h4 className='mb-0'>
                                            {product?.platform_product?.name + ' -'}
                                            <span className='text-secondary'>
                                              {product?.name == 'Default Title' ? ' ' : product?.name}{' '}
                                            </span>
                                          </h4>
                                          <h5 className='text-secondary'>{product?.sku}</h5>
                                        </div>
                                      </div>
                                      {isWrite && <button
                                        className={`m-4 text-end btn btn-success btn-sm d-flex align-items-center justify-content-center `}
                                        style={{ fontSize: '10px' }}
                                        onClick={() => {
                                          // if (
                                          //   matchedParentProduct &&
                                          //   matchedParentProduct?.platform_product?.id === product?.platform_product?.id
                                          // ) {
                                          //   // If the clicked product is already selected, deselect it
                                          //   console.log('Deselecting product:', product)
                                          //   setMatchedParentProduct(null)
                                          // } else {
                                          //   // Otherwise, select the clicked product
                                          //   console.log('Selecting product:', product)
                                          // }
                                          setMatchedParentProduct(product)
                                          setOpenConnectConfirmation(true)
                                        }}
                                      >
                                        {matchedParentProduct &&
                                          matchedParentProduct?.id === product?.id ? 'Selected' : 'Select'}
                                        {matchedParentProduct &&
                                          matchedParentProduct?.platform_product?.id ===
                                          product?.platform_product?.id && (<FontAwesomeIcon icon={faArrowRight} className='ms-2' />)}
                                      </button>}
                                    </div>
                                  </div>
                                </div>
                              )
                            )
                          ) : (
                          <div>
                            <h6>No item founds</h6>
                          </div>
                        )}
                      </Tab>
                    ))}
                </Tabs>
              </Modal.Body>

              <Modal.Footer>
                <div>
                  <strong>Showing {productRecordRange?.startRecord} - {productRecordRange?.endRecord} of{' '}
                    {productVarientsFromMainChannel.ProductVarientCountFromMainChannel} Records{' '}</strong>
                </div>
                <Button
                  onClick={() => handlePagination(paginationMainData.page - 1)}
                  disabled={productVarientsFromMainChannel.previous == null}
                >
                  <FontAwesomeIcon icon={faChevronLeft} />
                </Button>
                <Button
                  onClick={() => handlePagination(paginationMainData.page + 1)}
                  disabled={productVarientsFromMainChannel.next == null}
                >
                  <FontAwesomeIcon icon={faChevronRight} />
                </Button>
                <Button variant='secondary' onClick={handleClose}>
                  Close
                </Button>
                {/* <Button variant='primary' onClick={handleLinkProductVariant}>
            Save Changes
          </Button> */}
              </Modal.Footer>
            </Modal>

            <CSVUploadModal
              show={showUploadModal}
              handleClose={handleCloseUploadModal}
              id={platformModalId}
              platformData={platformData}
            // handleUploadCSV={() => handleUploadCSVFile(csvFile)}
            />

            {currentChannelData?.is_product_mapping_allowed && (
              <BulkProductLinking
                show={showBulkProductLinkingModal}
                handleClose={handleCloseBulkProductLinkingModal}
                id={platformModalId}
                platformData={platformData}
                available_map={currentChannelData?.available_map}
              // handleUploadCSV={() => handleUploadCSVFile(csvFile)}
              />
            )}

            <CommonAlertModal
              title='The Selected Product will going to be matched with this listing. Do you want to continue?'
              subtitle=''
              onSuccess={() => handleLinkProductVariant(activeTab)}
              onCancel={() => {
                setOpenConnectConfirmation(false)
                setMatchedParentProduct(null)
              }}
              cancelBtnTitle='Close'
              successBtnTitle='Yes confirm'
              isVisible={openConnectConfirmation}
              isTermsVisible={false}
              setIsVisible={() => { }}
              successDisabled={linkingCompleted}
            />
            <CommonAlertModal
              key={'reffresh data modal'}
              isVisible={showRefreshModal}
              successDisabled={refreshing}
              onCancel={() => {
                setShowRefreshModal(false)
                setRefreshPlatformId(null)
              }}
              onSuccess={() => {
                if (refreshPlatformId) {
                  setRefreshing(true)
                  dispatch(refreshPlatformDataAsync({ platformId: refreshPlatformId })).then(
                    (response) => {
                      successToast(
                        response.payload?.data?.message
                          ? response.payload?.data?.message : JSON.stringify(response.payload?.data?.message))
                      setRefreshing(false)
                      setRefreshPlatformId(null)
                      setShowRefreshModal(false)
                    }
                  )
                }
              }}
              title='Are you sure ?'
              subtitle='This might take 10-15 minutes to complete'
              isTermsVisible={false}
            />

            <CommonAlertModal
              key={'delist confirmation modal'}
              title={`Are You Sure You Want to ${selectedAction === 'full_update'
                ? 'Fully Update All Products' : 'Update the Selected Products'}?`}
              subtitle=''
              successBtnTitle={isDelistIng ? 'Delisting...' : 'Yes Confirm'}
              isTermsVisible={false}
              isVisible={opnDelistModal}
              onSuccess={() => {
                if (!id) {
                  return
                }
                setIsDelistIng(true)
                dispatch(
                  delistVariantsAsync({ platform_id: Number(id), delist_variant_ids: selectedItemForActions, type: selectedAction, })
                )
                  .then((response) => {
                    const capitalize = (str: string) =>
                      str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()
                    const platform = capitalize(currentChannelData?.self_data?.name || 'platform')
                    const bulkActionErrorFallback =
                      'Failed to update product listing status. Please try again.'

                    if (isApiPayloadSuccess(response)) {
                      if (response?.payload?.message) {
                        successToast(
                          `Your request has been successfully submitted to ${platform}. Updates will reflect on ${platform}'s platform once their API processes the request, which can take 15-20 minutes or longer. If you don't see the status change by then, please don't hesitate to contact our support team.`
                        )
                      }
                    } else {
                      errorToast(getApiErrorMessage(response, bulkActionErrorFallback))
                    }
                    setSelectedAction('')
                    setOpnDelistModal(false)
                    setIsDelistIng(false)
                  })
                  .catch((error) => {
                    errorToast(
                      getApiErrorMessage(
                        error,
                        'Failed to update product listing status. Please try again.'
                      )
                    )
                    setIsDelistIng(false)
                  })
              }}
              onCancel={() => {
                setOpnDelistModal(false)
                setSelectedAction('')
              }}
            />

            <UploadCsvModal show={showUploadModal} handleClose={handleUploadModalClose} platformId={id} connectedPlatformTypes={connectedPlatformTypes} />

            <CommonAlertModal
              title={`Are you sure you want to delete "${selectedProduct?.name || "this product"}"?`}
              subtitle="This product will be deleted permanently."
              isVisible={showDeleteModal}
              isTermsVisible={false}
              onSuccess={handleDeleteConfirm}
              onCancel={handleDeleteCancel}
              successBtnTitle={isDeleting ? "Deleting..." : "Yes, Delete"}
              cancelBtnTitle="Cancel"
              successBtnClasses="btn btn-sm btn-danger m-2"
              successDisabled={isDeleting}
            />
          </div>
        </>
      )}
    </>
  )
}

export default ProductsTable
